import React from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';

import { WithAccountPermitsChecker } from 'Controllers/AccountPermitsChecker/AccountPermitsChecker.helpers';
import { formatText } from 'Utilities/formatters';
import proPropTypes from 'Utilities/proPropTypes';

T.setTexts(require('Components/texts.json'));

export const PRICE_DETAILS_TYPES = {
	MAX_BID: 'MAX_BID',
	SOLD_FOR: 'SOLD_FOR',
	VEHICLE_OFFER: 'VEHICLE_OFFER',
	WINNING_BID: 'WINNING_BID',
};

const getOfferType = ({ permits, type }) =>
	({
		[PRICE_DETAILS_TYPES.SOLD_FOR]: permits.getSoldForPrice(),
		[PRICE_DETAILS_TYPES.MAX_BID]: permits.getMaxBidPrice(),
		[PRICE_DETAILS_TYPES.VEHICLE_OFFER]: permits.getOfferDetails(),
		[PRICE_DETAILS_TYPES.WINNING_BID]: permits.getWinningBid(),
	})[type];

const PriceDetails = (props) => {
	const { permits, type = PRICE_DETAILS_TYPES.VEHICLE_OFFER } = props;

	const offerDetails = getOfferType({ permits, type });
	const { label, showVAT, value } = offerDetails;

	if (!offerDetails || !value) {
		return null;
	}

	return (
		<>
			{T.translate(`account.vehicleCard.${label}`, { value: <strong>{`£${formatText(value)}`}</strong> })}

			{showVAT ? ' +VAT' : null}
		</>
	);
};

PriceDetails.propTypes = {
	permits: proPropTypes.accountPermitsChecker.isRequired,
	type: PropTypes.oneOf(Object.values(PRICE_DETAILS_TYPES)),
};

export default WithAccountPermitsChecker()(PriceDetails);
